export const MEMBERS = [
    {
      id: 1,
      name: "Carolien Bloeme",
    },
    {
      id: 2,
      name: "Sun Jun",
    },
    {
      id: 3,
      name: "Song Bao",
    },
    {
      id: 4,
      name: "Olivia Arribas",
    },
    {
      id: 5,
      name: "Bonginkosi Mdladlana",
    },
    {
      id: 6,
      name: "Arina Belomestnykh",
    },
    {
      id: 7,
      name: "aqueline Likoki",
    },
  ];